export enum pagePathEnum {
    HOME = '/',
    ABOUT_US = '/about-us',
    SERVICES = '/services',
    CAREERS = '/careers',
    CONTACT_US = '/contact-us',
    APPLY_FORM = '/apply-form'
}